import { call, put, takeEvery } from 'redux-saga/effects'
import {
  GET_CATALOG_ITEMS,
  ADD_CATALOG_ITEM,
  UPDATE_CATALOG_ITEM,
  DELETE_CATALOG_ITEM,
} from './actionTypes'

import {
  getCatalogItemsSuccess,
  getCatalogItemsFail,
  addCatalogItemSuccess,
  addCatalogItemFail,
  updateCatalogItemSuccess,
  updateCatalogItemFail,
  deleteCatalogItemSuccess,
  deleteCatalogItemFail,
  setFieldErrors,
} from './actions'
import axiosInstance from 'pages/Utility/axiosInstance'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'

// API calls
const fetchCatalogItemsApi = ({id}) => axiosInstance.get('', { params: { sp: 'usp_GetCatalogues' ,solutionId:id} })
const addCatalogItemApi = (item) => axiosInstance.post('', item)
const updateCatalogItemApi = (item) => axiosInstance.post('', item)
const deleteCatalogItemApi = (id) =>
  axiosInstance.post('', { sp: 'usp_DeleteCatalogue', catalogueId: id })

// Sagas
function* getCatalogItemsSaga(action) {
  try {
    const { data } = yield call(fetchCatalogItemsApi,action.payload)
    yield put(getCatalogItemsSuccess(data))
  } catch (error) {
    yield put(getCatalogItemsFail(error.response?.data || error.message))
  }
}

function* addCatalogItemSaga(action) {
  try {
    const { data } = yield call(addCatalogItemApi, action.payload.item)
    yield put(addCatalogItemSuccess(data))
    action.payload.navigate('/catalogues')
    action.payload.resetForm()
    toast.success('Catalogue item added successfully!')
    yield put({ type: GET_CATALOG_ITEMS })
  } catch (error) {
    if (error.response?.status === 400 && error.response?.data?.fieldErrors) {
      yield put(setFieldErrors(error.response.data.fieldErrors))
    } else {
      yield put(addCatalogItemFail(error.response?.data || error.message))
    }
  }
}

function* updateCatalogItemSaga(action) {
  try {
    const { data } = yield call(updateCatalogItemApi, action.payload.item)
    yield put(updateCatalogItemSuccess(data))
    action.payload.navigate('/catalogues')
    toast.success('Catalogue item updated successfully!')
    yield put({ type: GET_CATALOG_ITEMS })
  } catch (error) {
    if (error.response?.status === 400 && error.response?.data?.fieldErrors) {
      yield put(setFieldErrors(error.response.data.fieldErrors))
    } else {
      yield put(updateCatalogItemFail(error.response?.data || error.message))
    }
  }
}

function* deleteCatalogItemSaga(action) {
  try {
    yield call(deleteCatalogItemApi, action.payload)
    yield put(deleteCatalogItemSuccess(action.payload))
    toast.success('Catalogue item deleted successfully!')
    yield put({ type: GET_CATALOG_ITEMS })
  } catch (error) {
    yield put(deleteCatalogItemFail(error.response?.data || error.message))
  }
}

// Watcher saga
function* catalogSaga() {
  yield takeEvery(GET_CATALOG_ITEMS, getCatalogItemsSaga)
  yield takeEvery(ADD_CATALOG_ITEM, addCatalogItemSaga)
  yield takeEvery(UPDATE_CATALOG_ITEM, updateCatalogItemSaga)
  yield takeEvery(DELETE_CATALOG_ITEM, deleteCatalogItemSaga)
}

export default catalogSaga
